import { call, put, takeLatest, delay } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { GOOGLE_SPOT, MINI_APP_CONSTANTS } from '../constants';
import { StatusCodes } from 'http-status-codes';
import { googleSpotInitiatePaymentSuccess, googleSpotInitiatePaymentFailure, googleSpotValidateResponseSuccess, googleSpotValidateResponseFailure, googleSpotCheckTransactionStatusSuccess, googleSpotCheckTransactionStatusFailure, } from '../redux/Actions/PaymentGoogleSpotActions';
const isSuccessResponse = (httpResponse) => {
    return (httpResponse?.status === StatusCodes.OK ||
        httpResponse?.status === StatusCodes.CREATED ||
        httpResponse?.status === StatusCodes.ACCEPTED);
};
function* makeApiCall(request, httpOptions) {
    const { payload } = request;
    const { tenantId, body } = payload;
    const headers = {
        'x-tenant-id': tenantId,
    };
    return yield call(invokeApi, httpOptions, null, headers, body);
}
export function* initiatePaymentRequest(request) {
    try {
        const result = yield call(makeApiCall, request, networkConfig.googleSpotInitiatePayment);
        if (isSuccessResponse(result)) {
            yield put(googleSpotInitiatePaymentSuccess(result?.response));
        }
        else {
            yield put(googleSpotInitiatePaymentFailure());
        }
    }
    catch (error) {
        yield put(googleSpotInitiatePaymentFailure());
    }
}
export function* googleSpotInitiatePaymentSaga() {
    yield takeLatest(GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST, initiatePaymentRequest);
}
export function* validateResponseRequest(request) {
    try {
        const result = yield call(makeApiCall, request, networkConfig.googleSpotValidateResponse);
        if (isSuccessResponse(result) &&
            (result?.response?.status === MINI_APP_CONSTANTS.SUCCESS ||
                result?.response?.status === MINI_APP_CONSTANTS.FAILURE)) {
            yield put(googleSpotValidateResponseSuccess(result?.response));
        }
        else {
            yield put(googleSpotValidateResponseFailure());
        }
    }
    catch (error) {
        yield put(googleSpotValidateResponseFailure());
    }
}
export function* googleSpotValidateResponseSaga() {
    yield takeLatest(GOOGLE_SPOT.VALIDATE_RESPONSE, validateResponseRequest);
}
export function* checkTransactionStatusRequest(request) {
    const { payload } = request;
    const { tenantId, transactionId, retryCount = MINI_APP_CONSTANTS.API_RETRY_COUNT } = payload;
    const headers = {
        'x-tenant-id': tenantId,
    };
    let isPendingResponse = true;
    for (let i = 0; i < retryCount; i++) {
        try {
            const result = yield call(invokeApi, networkConfig.googleSpotCheckTransactionStatus, { queryProps: { transactionId } }, headers);
            if (isSuccessResponse(result) &&
                (result?.response?.status === MINI_APP_CONSTANTS.SUCCESS ||
                    result?.response?.status === MINI_APP_CONSTANTS.FAILURE)) {
                isPendingResponse = false;
                yield put(googleSpotCheckTransactionStatusSuccess(result?.response));
                break;
            }
            yield delay(MINI_APP_CONSTANTS.STATUS_DELAY_TIME);
        }
        catch (err) {
            if (i < retryCount - 1) {
                yield delay(MINI_APP_CONSTANTS.STATUS_DELAY_TIME);
            }
            else {
                yield put(googleSpotCheckTransactionStatusFailure());
            }
        }
    }
    if (isPendingResponse) {
        yield put(googleSpotCheckTransactionStatusFailure());
    }
}
export function* googleSpotCheckTransactionStatusSaga() {
    yield takeLatest(GOOGLE_SPOT.CHECK_TRANSACTION_STATUS, checkTransactionStatusRequest);
}
